/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { signInActions } from '../sign-in/slice';

/**
 * Define the user invites feature initial state
 */
export const initialState = {
  loading: false,
  userInvitesList: [],
  usersList: [],
  roleList: [],
};
/**
 * Here mentioned all the user invites feature related actions
 */
export const userInvitesSlice = createSlice({
  name: 'feature/user-invites',
  initialState,
  reducers: {
    getUserInvites(state) {
      state.loading = true;
    },
    getUserInvitesSucceeded(state, action) {
      state.loading = false;
      state.userInvitesList = action?.payload?.results;
    },
    getUserInvitesFailed(state) {
      state.loading = false;
    },
    usersList(state) {
      state.loading = true;
    },
    usersListSucceeded(state, action) {
      state.loading = false;
      state.usersList = action?.payload?.results;
    },
    usersListFailed(state) {
      state.loading = false;
    },
    getRoles(state) {
      state.loading = true;
    },
    getRolesSucceeded(state, action) {
      state.loading = false;
      state.roleList = action?.payload?.results;
    },
    getRolesFailed(state) {
      state.loading = false;
    },
    resendInvite(state) {
      state.loading = true;
    },
    resendInviteSucceeded(state) {
      state.loading = false;
    },
    resendInviteFailed(state) {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: userInvitesActions } = userInvitesSlice;
